export default "/static/cellometer_tiny.png";